import React, { useState, useEffect, useMemo } from "react";
import { addStudentLifeData, getStudentLifeData, editStudentLifeData, deleteStudentLifeData } from "../../controllers/studentLife.controller"
import toast from 'react-hot-toast';
import {
    IconPlus,
} from "@tabler/icons-react";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import Button from "../../Components/Button";
import Page from "../../Components/Page";

const StudentLife = () => {

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [toggeledIndex_1, setToggeledIndex] = useState(0);

    const [formData, setFormData] = useState({
        description: "",
        club_name: "",
        images: [],
    });

    const [existingImagePaths, setExistingImagePaths] = useState([]);

    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const fetchTableData = async () => {
        const res = await getStudentLifeData({})

        if (res.status === 200) {
            const apiData = res?.data?.data;
            setData(apiData)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    // add
    const addNewStLife = async () => {
        try {
            const { club_name, description, images } = formData;

            if (!club_name || !description || images.length === 0) {
                toast.error("Please fill in all the required fields and upload at least one image.");
                return;
            }

            toast.loading("Submitting your data...");

            const formDataToSend = new FormData();

            formDataToSend.append("club_name", club_name);
            formDataToSend.append("description", description);
            images.forEach(image => {
                formDataToSend.append("file", image);
            });

            const res = await addStudentLifeData(formDataToSend);

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    club_name: "",
                    description: "",
                    images: [],
                });

                fetchTableData()
            } else {
                toast.error(message || "Failed to add data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding data:", error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    const removeExistingImage = (index) => {
        setExistingImagePaths(prevState => {
            const newPaths = [...prevState];
            newPaths.splice(index, 1);
            return newPaths;
        });
    };

    // edit
    const editReseachBtn = async () => {
        try {
            const { club_name, description, images } = formData;

            if (!club_name || !description) {
                toast.error("Please fill in all the required fields.");
                return;
            }

            toast.loading("Submitting your data...");

            const formDataToSend = new FormData();

            formDataToSend.append("club_name", club_name);
            formDataToSend.append("description", description);

            if (images && images.length > 0) {
                images.forEach(image => {
                    formDataToSend.append("file", image);
                });
            }

            //Append existing image paths as a JSON string
            formDataToSend.append("existing_images", JSON.stringify(existingImagePaths));

            const res = await editStudentLifeData(selectedRowId, formDataToSend);

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    club_name: "",
                    description: "",
                    images: [],
                });

                setExistingImagePaths([]);

                document.getElementById("modal-edit").close()
                fetchTableData()
            } else {
                toast.error(message || "Failed to add data.");
            }
        } catch (error) {
            toast.dismiss();
            document.getElementById("modal-edit").close()
            console.error("Error adding data:", error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };


    // delete
    const deleteStLifeBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteStudentLifeData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    const handleImageChange = (event) => {

        const files = Array.from(event.target.files);
        setFormData(prevState => ({
            ...prevState,
            images: [...prevState.images, ...files],
        }));
    };

    //Function to remove image from array
    const removeImage = (index) => {
        setFormData(prevState => {
            const newImages = [...prevState.images];
            newImages.splice(index, 1);
            return { ...prevState, images: newImages };
        });
    };

    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])

    return (
        <Page className="px-8 py-6">
            <div className='flex items-center gap-10 text-xl'>
                <div className="text-[#100f13]">
                    Research & Student Life / Student Life /
                    <span className="text-[black] bg-white mt-6"> Clubs and Societies</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full p-6 mx-auto mt-10 bg-white rounded-lg shadow-lg">
                {toggeledIndex === 1 ? (
                    <div>
                        <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6">Club / Society List</h1>

                        <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                            <thead>
                                <tr className="bg-gray-100 text-[#4B465C]">

                                    <th className="w-1/4 px-4 py-2 text-center">Club Name</th>

                                    <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id} className="border-b hover:bg-gray-50">

                                        <td className="px-4 py-2 text-center">{item.club_name}</td>

                                        <td className="px-4 py-2 text-center">
                                            <div className="flex justify-center gap-4">
                                                <button
                                                    onClick={() => {
                                                        setSelectedRowId(item.id)
                                                        document.getElementById("modal-delete").showModal();
                                                    }}
                                                    className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                >
                                                    Delete
                                                    <RiDeleteBin2Line className="ml-2" />
                                                </button>

                                                <button onClick={() => {

                                                    setSelectedRowId(item.id)
                                                    setFormData((prevState) => ({
                                                        ...prevState,
                                                        club_name: item.club_name,
                                                        description: item.description,
                                                        images: [],
                                                    }));

                                                    // Use the 'image_path' directly, split by comma if it's a string of comma-separated paths
                                                    const imagePaths = typeof item.image_path === 'string' ? item.image_path.split(',') : (item.image_path ? [item.image_path] : []);
                                                    setExistingImagePaths(imagePaths);

                                                    document.getElementById("modal-edit").showModal();
                                                }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                    Edit
                                                    <FiEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="container">
                        <div className="p-6 mx-auto bg-white rounded-lg shadow-md">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <h1 className="mb-4 text-xl font-bold text-gray-700">Add Club/Society Details</h1>

                                {/* Club Name Input */}
                                <div className="mb-4">
                                    <label htmlFor="club_name" className="block mb-2 text-gray-600">
                                        Club Name
                                    </label>
                                    <input
                                        type="text"
                                        id="club_name"
                                        name="club_name"
                                        value={formData.club_name}
                                        onChange={handleChange}
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                </div>


                                <div className="w-full mb-4 text-left">
                                    <label className="block mb-1 font-medium text-gray-600">
                                        Description
                                    </label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        rows="4"
                                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                    />
                                </div>
                                <div className="mb-6">
                                    <h1 className="block text-black font-medium mb-2 text-[18px]">
                                        Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                    </h1>
                                    <div className="flex flex-col">
                                        <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:text-[#92288C] hover:bg-[#92288C14]">
                                            <input
                                                type="file"
                                                accept=".jpg, .png"
                                                multiple
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                            Browse Images
                                        </label>
                                        {formData.images.length > 0 && (
                                            <div className="mt-2">
                                                {formData.images.map((image, index) => (
                                                    <div key={index} className="flex items-center justify-between py-2 border-b">
                                                        <span>{image.name}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => removeImage(index)}
                                                            className="text-red-500"
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="flex justify-end space-x-4">
                                    <button
                                        className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                                        onClick={() => {
                                            setFormData({ club_name: "", description: "", images: [] });
                                            setToggeledIndex(1);
                                        }}
                                    >
                                        Back
                                    </button>
                                    <button
                                        type="button"
                                        onClick={addNewStLife}
                                        className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175]"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                )
                }
            </div>
            <dialog
                id="modal-edit"
                className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
            >
                <div className="p-6">
                    <h1 className="mb-6 text-2xl font-bold">Edit  Club/Society</h1>
                    <form onSubmit={(e) => e.preventDefault()}>

                        <div className="mb-4">
                            <label htmlFor="club_name" className="block mb-2 text-gray-600">
                                Club Name
                            </label>
                            <input
                                type="text"
                                id="club_name"
                                name="club_name"
                                value={formData.club_name}
                                onChange={handleChange}
                                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                            />
                        </div>

                        <div className="w-full mb-4 text-left">
                            <div>
                                <label className="block mb-1 font-medium text-gray-600"> Description</label>

                                <textarea

                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    rows="4"

                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                />

                            </div>

                        </div>
                        <div className="mb-6">
                            <h1 className="block text-black font-medium mb-2 text-[18px]">
                                Logo <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                            </h1>
                            <div className="flex flex-col">
                                <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:text-[#92288C] hover:bg-[#92288C14]">
                                    <input
                                        type="file"
                                        accept=".jpg, .png"
                                        multiple
                                        onChange={handleImageChange}
                                        className="hidden"
                                    />
                                    Browse Images
                                </label>

                                {/* Display existing image paths */}
                                {existingImagePaths.length > 0 && (
                                    <div className="mt-2">
                                        <p className="mb-2 font-semibold">Current Images:</p>
                                        {existingImagePaths.map((path, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <p>{path}</p>
                                                <button
                                                    type="button"
                                                    onClick={() => removeExistingImage(index)}
                                                    className="text-red-500"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {formData.images.length > 0 && (
                                    <div className="mt-2">
                                        {formData.images.map((image, index) => (
                                            <div key={index} className="flex items-center justify-between py-2 border-b">
                                                <span>{image.name}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => removeImage(index)}
                                                    className="text-red-500"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-end space-x-4">

                            <button
                                className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                                onClick={() => {
                                    setSelectedRowId(null)
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        club_name: "",
                                        description: "",
                                        images: [],
                                    }));
                                    setExistingImagePaths([]);
                                    document.getElementById("modal-edit").close()
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => editReseachBtn()}
                                className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                            >
                                save
                            </button>


                        </div>
                    </form>
                </div>
            </dialog>

            <dialog
                id="modal-delete"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
            >

                <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="font-bold text-gray-500">
                            Are you sure?
                        </p>
                    </div>


                    <div className="flex justify-center mt-4 space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => { deleteStLifeBtn(); }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </Page>

    );
};

export default StudentLife;